import { ActionButtons, Footer } from "@ucl/library";
import { TaskExecutionModuleProps } from "../TaskExecutionModuleProps";

export const SendEmailTaskExecutionTypeModule: React.FC<
  TaskExecutionModuleProps
> = (props) => {
  return (
    <div className="send-email-task-execution-type-module">
      <Footer>
        <ActionButtons
          actions={[
            {
              text: "Send Email",
              isPrimary: true,
              onActionClick: () => {
                props.onTaskComplete?.(props.taskExecutionTypeFields);
              },
            },
          ]}
        />
      </Footer>
    </div>
  );
};
